export const en = {
  common: {
    loading: 'Loading...',
    back: 'Back',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    apply: 'Apply',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    next: 'Next',
    previous: 'Back',
    skip: 'Skip',
    done: 'Done',
    error: 'Error',
    success: 'Success',
    saving: 'Saving...',
    deleting: 'Deleting...',
    optional: '(optional)',
    required: 'required',
    chooseFile: 'Choose file',
    nothingFound: 'Nothing found',
    untitled: 'Untitled',
    description: 'Description',
    title: 'Title',
    name: 'Name',
    date: 'Date',
    actions: 'Actions',
    all: 'All',
    status: 'Status',
    category: 'Category',
    amount: 'Amount',
    filters: 'Filters',
    search: 'Search',
    selected: 'Selected',
    currency: 'Currency',
  },
  errors: {
    generic: 'Something went wrong. Please try again later.',
    authTitle: 'Authentication error',
    devMode: 'Development mode',
    devModeHint: 'Open the app through Telegram for full functionality',
    notFound: 'Not found',
    forbidden: 'Access denied',
    loadTitle: 'Could not load the app',
    loadHint: 'Check your connection and try again.',
    reload: 'Reload',
    networkError: 'Network error',
  },
  language: {
    label: 'Language',
    ru: 'Русский',
    en: 'English',
    kk: 'Қазақша',
  },
  announcement: {
    eyebrow: 'What’s new',
    next: 'Next',
    gotIt: 'Got it',
  },
  tabs: {
    collections: 'Collections',
    dashboard: 'Home',
    expenses: 'Expenses',
    materials: 'Materials',
    stages: 'Stages',
    profile: 'Profile',
  },
  login: {
    title: 'Sign in to etap',
    subtitle: 'Sign in to continue managing your renovation',
    telegramBtn: 'Sign in with Telegram',
    telegramSigningIn: 'Signing in…',
    telegramConfirm: 'Confirm sign-in in the Telegram window. If it did not open, allow popups and try again.',
    telegramUnavailable: 'Could not load Telegram. Check your connection and try again.',
    telegramFailed: 'Could not sign in with Telegram. Please try again.',
    telegramExpired: 'Your sign-in session was refreshed. Please click the button again.',
    retry: 'Try again',
    cancel: 'Cancel',
    yandexBtn: 'Sign in with Yandex',
    or: 'or',
    benefits: 'Secure sign-in · No password needed',
    miniAppHint: 'Or use it right inside Telegram —',
    miniAppLink: 'open the Mini App',
  },
  legal: {
    loginNotice: 'By signing in, you accept the',
    loginTerms: 'Terms of Use',
    loginConsentPrefix: 'and give',
    loginConsent: 'consent to personal data processing',
    loginPolicyPrefix: 'under the',
    loginPolicy: 'Privacy Policy',
    documents: 'Documents',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    consent: 'Consent to data processing',
    cookieText: 'We use cookies and Yandex Metrica to keep the service working and make it better. By continuing, you agree to',
    cookieLink: 'data processing',
    cookieOk: 'Got it',
  },
  onboarding: {
    step1Title: 'Welcome to etap',
    step1Desc: 'Renovation and budget control in one place.',
    step2Title: 'Create a project',
    step2Desc: 'Give the project a name and set a budget.',
    step3Title: 'Invite your team',
    step3Desc: 'Up to 5 people — partners, family, contractors.',
    step4Title: 'You are all set!',
    step4Desc: 'Manage expenses and stages together with your team.',
    skip: 'Skip',
    start: 'Start',
    budgetOptionalHint: 'Optional — you can add it later',
  },
  stories: {
    report: {
      title: 'New report',
      desc: 'A fresh project report is ready',
      cta: 'Open report',
    },
    poll: {
      thanks: 'Thank you for your answer',
      thanksSub: 'Your feedback is recorded and helps us improve the product.',
      step: 'Question {{current}} of {{total}}',
    },
    renovation: {
      day: {
        circle: 'Renovation day',
        slideTitle: 'Day {{day}} of renovation',
        slideSub: 'Track your progress and keep the renovation under control.',
      },
      expenses: {
        title: 'Expenses',
        desc: 'Log costs for work and materials — see monthly and total spend at a glance',
      },
      stages: {
        title: 'Stages',
        desc: 'Plan your renovation step by step with checklists — track progress in real time',
      },
      materials: {
        title: 'Purchases',
        desc: 'Build a materials list, record prices and statuses',
      },
      ai: {
        title: 'AI analysis',
        desc: 'AI reviews your budget and gives tips — available after a few entries',
      },
      team: {
        title: 'Team',
        desc: 'Invite a partner or contractor via link — up to 5 people per project',
      },
    },
    finance: {
      expenses: {
        title: 'Expenses',
        desc: 'Log spending by category and view analytics for any period',
      },
      analytics: {
        title: 'Analytics',
        desc: 'Charts and category breakdown — always know where your money goes',
      },
      multicurrency: {
        title: 'Multi-currency',
        desc: 'Roubles, dollars, euros and crypto — all expenses in one project',
      },
      ai: {
        title: 'AI advisor',
        desc: 'Smart spending analysis: anomalies, trends and budget leaks highlighted',
      },
      report: {
        title: 'Report',
        desc: 'Weekly expense summary delivered to Telegram',
      },
    },
  },
  profile: {
    title: 'Profile',
    settings: 'Settings',
    logout: 'Sign out',
    logoutAll: 'Sign out of all devices',
    language: 'Interface language',
    defaultCurrency: 'Default currency',
    weeklyReport: 'Weekly report',
    weeklyReportDesc: 'Get a project summary in Telegram',
    sendNow: 'Send now',
    sendOk: 'Report sent to Telegram',
    sendInProgress: 'Sending...',
    sendCooldown: 'Can be sent once per day',
    selectProject: 'Pick a project for the report',
    enableReport: 'Enable report',
    dayLabel: 'Day of the week',
    days: {
      0: 'Sunday',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday',
    },
    timeZone: 'Time zone',
    timeZoneAuto: 'Detected automatically: {{tz}}',
    saving: 'Saving...',
    saved: 'Saved',
    confirmLogout: 'Sign out?',
    confirmLogoutAll: 'Sign out of all devices?',
    support: 'Support',
    feedback: 'Send feedback',
    aboutApp: 'About the app',
    versionLabel: 'Version',
  },
  dashboard: {
    settingsTitle: 'Home screen setup',
    settingsHint: 'Pick what comes first and large. The other blocks can be hidden with the eye on the right.',
    settingsMainBadge: 'main',
    settingsShow: 'Show',
    settingsHide: 'Hide',
    blockFinance: 'Budget',
    blockFinanceDesc: 'Spent, remaining, planned expenses',
    blockStages: 'Stages',
    blockStagesDesc: 'Current stage and work progress',
    blockPlans: 'Floor plan',
    blockPlansDesc: 'Your layout, area and rooms',
    blockMaterials: 'Materials',
    blockMaterialsDesc: 'Products you are choosing between',
    blockReports: 'AI reports',
    blockReportsDesc: 'Weekly breakdown of your spending',
    plansHeroEmpty: 'Draw your apartment — room areas are calculated for you.',
    plansHeroOpen: 'Open the planner',
    plansHeroCount_one: '{{count}} more',
    plansHeroCount_other: '{{count}} more',
    title: 'Home',
    chooseProject: 'Pick a project',
    chooseProjectHint: 'Create your first project to get started',
    newProject: 'New project',
    selectProjectLabel: 'Active project',
    activeProject: 'Active project',
    switchProject: 'Switch project',
    settings: 'Project settings',
    inviteMembers: 'Invite members',
    budgetTotal: 'Budget',
    spent: 'Spent',
    remaining: 'Remaining',
    overspent: 'Overspent',
    progress: 'Progress',
    quickActions: 'Quick actions',
    actionAddExpense: 'Add expense',
    actionOpenStages: 'Stages',
    actionOpenMaterials: 'Product collections',
    actionOpenKanban: 'Kanban',
    recentExpenses: 'Recent expenses',
    seeAll: 'All →',
    noExpenses: 'No expenses yet',
    addFirstExpense: 'Add your first expense',
    stagesProgress: 'Stage progress',
    noStages: 'No stages yet',
    upcomingPlanned: 'Awaiting payment',
    of: 'of',
    projectsCount_one: '{{count}} project',
    projectsCount_few: '{{count}} projects',
    projectsCount_many: '{{count}} projects',
    projectsCount_other: '{{count}} projects',
    myProjects: 'My projects',
    roleEditor: 'Editor',
    roleViewer: 'Viewer',
    membersWithCount: 'Members ({{count}}/{{limit}})',
    editProject: 'Edit project',
    deleteCurrentProject: 'Delete current project',
    deletingProject: 'Deleting...',
    leavingProject: 'Leaving...',
    leaveProject: 'Leave project',
    deleteOnlyProjectConfirm: 'Are you sure you want to delete the project? This is your only project, and all data will be lost.',
    deleteProjectConfirm: 'Delete project "{{title}}"? All expenses and project data will be deleted.',
    leaveProjectConfirm: 'Leave project "{{title}}"?',
    monthSpent: 'this month',
    draftsCount_one: '{{count}} expense',
    draftsCount_other: '{{count}} expenses',
    draftsOverRemaining: 'more than remaining',
    plannedShort: 'Planned',
    periodSpend: 'Spent in period',
    nextStage: 'Next',
    quickRepairDay: 'Reno day',
    quickAi: 'AI reports',
    progressUsed: '{{percent}}% used',
    aiGateTitle: 'Foreman AI — expense analysis',
    aiGateTitleFinance: 'AI advisor — financial analysis',
    aiGateDesc: 'For an accurate analysis, fill in project details and add the first expenses.',
    aiGateDescFinance: 'Add a few expenses so the AI can start analysing your finances.',
    areaRequired: 'Apartment area',
    notSpecified: 'Not specified',
    specify: 'Specify',
    minExpenses: 'At least 3 expenses',
    expensesEntered: '{{count}} of {{required}} entered',
    aiObservation_one: '{{count}} observation',
    aiObservation_few: '{{count}} observations',
    aiObservation_many: '{{count}} observations',
    aiObservation_other: '{{count}} observations',
    aiLabelInfo: 'Observation',
    aiLabelWarning: 'Attention',
    aiLabelAlert: 'Important',
    aiLabelTip: 'Tip',
    aiNoObservations: 'No observations yet',
    aiRefreshAvailable: 'Refresh available',
    aiNextReport: 'Next report in {{time}}',
    details: 'Details',
    spentAllTime: 'Total spent',
    allTime: 'all time',
    currentPeriod: 'current period',
    next14Days: 'next 14 days',
    pricePerSqm: 'Price per m²',
    createStagesHint: 'Create stages to track progress',
    start: 'Start →',
    products: 'Collections',
    shoppingList: 'Product collections',
    itemsCount: 'items: {{count}}',
    planPurchases: 'Plan purchases',
    collectionsPitch: 'Choosing a faucet or tiles?',
    collectionsPitchSub: 'Save options from shops and compare prices',
    newBadge: 'New',
    weeklyReports: 'Weekly reports',
    weeklyReportForProject: 'Report for "{{title}}" every {{day}} at 10:00',
    weeklyReportGeneric: 'Telegram report every {{day}} at 10:00',
    reportDayAria: 'Report weekday',
    sendingReport: 'Sending...',
    nextReportAt: 'Next report {{time}}',
    sendReportNow: 'Send report now',
    noProjectsForReport: 'You do not have projects for a report yet',
    reportSent: 'Report sent to Telegram',
    reportSendError: 'Failed to send report',
    supportQuestion: 'Having trouble?',
    contactSupport: 'Contact support',
    viewAnnouncements: 'All announcements',
    weekdaysShort: {
      0: 'Sun',
      1: 'Mon',
      2: 'Tue',
      3: 'Wed',
      4: 'Thu',
      5: 'Fri',
      6: 'Sat',
    },
    weekdaysReport: {
      0: 'Sunday',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday',
    },
    period: {
      day: 'day',
      week: 'week',
      month: 'month',
      year: 'year',
      all: 'all time',
    },
  },
  expenses: {
    reportPromoTitle: 'A weekly report',
    reportPromoText: 'You have logged {{total}} so far. Once a week I will send a breakdown — nothing to read up on, it arrives on its own.',
    reportPromoPoint1: 'What you spent this week and on which categories',
    reportPromoPoint2: 'Where you went over a limit and which bills are overdue',
    reportPromoPoint3: 'How many weeks the remaining budget lasts',
    reportPromoAction: 'Turn the report on',
    title: 'Expenses',
    add: 'Add expense',
    edit: 'Edit expense',
    delete: 'Delete expense',
    deleteConfirm: 'Delete this expense?',
    splitConfirm: 'Split this expense?',
    splitTitle: 'Split expense',
    splitDesc: 'Part of the amount is paid now, the rest — later',
    splitPaidAmount: 'Paid now',
    splitRemaining: 'Remaining',
    splitBtn: 'Split',
    noExpenses: 'No expenses yet',
    noExpensesHint: 'Add the first expense to start tracking the budget',
    total: 'Total',
    monthTotal: 'This month',
    weekTotal: 'This week',
    filterStatus: 'Status',
    filterCategory: 'Category',
    filterPayee: 'Payee type',
    filterMethod: 'Payment method',
    filterDateFrom: 'Date from',
    filterDateTo: 'Date to',
    resetFilters: 'Reset filters',
    statusDraft: 'Planned',
    statusPending: 'Awaiting payment',
    statusPaid: 'Paid',
    statusCancelled: 'Cancelled',
    payeeContractor: 'Contractor',
    payeeOther: 'Other',
    methodCash: 'Cash',
    methodCard: 'Card',
    methodTransfer: 'Transfer',
    methodInvoice: 'Invoice',
    methodOther: 'Other',
    amount: 'Amount',
    amountPlaceholder: 'Enter the amount',
    descriptionPlaceholder: 'What was bought or paid for',
    contractorLabel: 'Contractor',
    contractorPlaceholder: 'Pick or type a name',
    storeLabel: 'Store',
    storePlaceholder: 'Store name',
    tagsLabel: 'Tags',
    chartTagSuggestions: 'Filter by tags',
    chartTagSuggestionsHint: 'Show expenses with a specific label',
    filterByTag: 'Filter by tag {{tag}}',
    clearTagFilter: 'Clear tag filter {{tag}}',
    tagsPlaceholder: 'For example: foreman-alex, home-depot',
    receipt: 'Receipt / photo',
    uploadReceipt: 'Attach photo',
    paymentDate: 'Payment date',
    deleteReceipt: 'Delete photo',
    chartCategory: 'By category',
    chartStatus: 'By status',
    aiNoSuggestions: 'No suggestions — add more expenses',
    aiSuggest: 'Suggest a category',
    receivedFrom: 'Payee',
    chartLabel: 'Summary',
    showChart: 'Show chart',
    hideChart: 'Hide chart',
    perCategory: 'By category',
    groupByMonth: 'By month',
    groupByWeek: 'By week',
    groupByDay: 'By day',
    overspentWarning: 'Category limit exceeded',
    copyExpense: 'Duplicate',
    filters: 'Filters',
    allCategories: 'All categories',
    subcategory: 'Subcategory',
    payeeBuilders: 'Builders',
    payeeDesigner: 'Designer',
    payeeLawyers: 'Lawyers',
    payeeStore: 'Store',
    paid: 'Paid',
    tabPaid: 'Paid',
    tabPlanned: 'Planned',
    drafts: 'Planned expenses',
    spend: 'Spend',
    aiAnalyzingProject: 'Foreman AI is analyzing the project...',
    retry: 'Retry',
    aiNoNewIdeas: 'Foreman AI did not find new ideas — looks like everything is already covered.',
    noExpensesFiltered: 'No expenses match the selected filters',
    noPlannedExpenses: 'No planned expenses yet',
    addFirst: 'Add first expense',
    draftsPlanned: 'Planned expenses',
    hideList: 'Hide list',
    showList: 'Show ({{count}})',
    unnamed: 'Untitled',
    advance: 'Part payment',
    filterPartlyPaid: 'Partly paid',
    plannedTotal: 'Planned',
    selectMode: 'Select',
    selectDone: 'Done',
    selectAll: 'Select all',
    selectNone: 'Clear',
    selectHint: 'Tick expenses to add them up',
    selectedCount: '{{count}} of {{total}} selected',
    fullPrice: 'Full price',
    paidByAdvance: 'Paid',
    remainder: 'Remaining',
    paymentProgress: 'Expense payment',
    advanceAmountLabel: 'Payment amount',
    editAdvance: 'Edit part payment',
    remainderHint: 'Paid {{paid}} · remaining {{remainder}}',
    fullPriceBelowAdvances: 'Full price must be greater than the amount already paid',
    advancePaid: 'paid {{paid}} of {{total}}',
    pay: 'Pay',
    paidPart: 'part of payment',
    toTop: 'To top',
    payAdvance: 'Add part payment',
    advanceHint: 'The amount you enter becomes paid, the rest stays in plans.',
    advanceAmount: 'Payment amount, ₽',
    createCopy: 'Create copy',
    copiedTitle: 'Expense copy',
    newTitle: 'New expense',
    basicInfo: 'Basic information',
    expenseName: 'Expense name',
    expenseNamePlaceholder: 'For example: First tile payment',
    note: 'Note',
    notePlaceholder: 'For example: what the work was for, or payment details',
    paymentDetails: 'Payment details',
    paidTo: 'Paid to',
    draftToggle: 'This is a planned expense',
    draftHint: 'Not paid yet and may still change. It counts towards plans, not actual spend. Pay part of it and record that part payment — the rest stays planned.',
    extra: 'Additional',
    tagsFilterTitle: 'Create filters that fit your work',
    tagsFilterDescription: 'Add custom labels to filter expenses more precisely — for example, by foreman name or store name.',
    tagsUsedLabel: 'Previously used',
    tagsHint: 'Separate tags with a comma or space',
    paymentHistory: 'Payment history',
    remainingDraft: 'Remaining in plans',
    mainPayment: 'Main payment',
    linkedExpense: 'Linked expense',
    invalidAmount: 'Enter a valid amount',
    nameRequired: 'Enter an expense name',
    saveError: 'Save error',
    loadError: 'Failed to load expense',
    deleteError: 'Failed to delete',
    uncategorized: 'Uncategorized',
    noSubcategory: 'No subcategory',
    categories: {
      'Стройматериалы': 'Building materials',
      'Работы': 'Labor',
      'Техника и оборудование': 'Equipment',
      'Услуги': 'Services',
      'Прочее': 'Other',
      'Еда и продукты': 'Food & Groceries',
      'Транспорт': 'Transport',
      'Жильё и ЖКУ': 'Housing & Utilities',
      'Здоровье': 'Health',
      'Развлечения': 'Entertainment',
      'Одежда и уход': 'Clothing & Care',
      'Образование': 'Education',
      'Техника и гаджеты': 'Electronics & Gadgets',
      'Маркетплейсы': 'Marketplaces',
      'Путешествия': 'Travel',
      'Кофе': 'Coffee',
    },
    subcategories: {
      'Материалы': 'Materials',
      'Черновые материалы': 'Rough materials',
      'Отделка': 'Finishing',
      'Плитка': 'Tiles',
      'Полы': 'Floors',
      'Потолки': 'Ceilings',
      'Окна и двери': 'Windows and doors',
      'Краска': 'Paint',
      'Обои': 'Wallpaper',
      'Сухие смеси и штукатурка': 'Dry mixes & plaster',
      'Гипсокартон и профиль': 'Drywall & framing',
      'Изоляция и гидроизоляция': 'Insulation & waterproofing',
      'Крепёж и расходники': 'Fasteners & consumables',
      'Кабель и электроматериалы': 'Cable & electrical supplies',
      'Трубы и фитинги': 'Pipes & fittings',
      'Плинтусы и молдинги': 'Skirting & mouldings',
      'Электромонтаж': 'Electrical installation',
      'Сантехмонтаж': 'Plumbing installation',
      'Плиточные работы': 'Tiling',
      'Малярные работы': 'Painting',
      'Потолочные работы': 'Ceiling work',
      'Напольные работы': 'Flooring work',
      'Установка окон и дверей': 'Window & door installation',
      'Сборка и установка мебели': 'Furniture assembly',
      'Бытовая техника': 'Home appliances',
      'Кухонная техника': 'Kitchen appliances',
      'Умный дом и слаботочка': 'Smart home & low-voltage',
      'Дизайн-проект': 'Interior design project',
      'Замеры': 'Measurements',
      'Аренда инструмента и техники': 'Tool & equipment rental',
      'Вывоз мусора': 'Waste removal',
      'Клининг после ремонта': 'Post-renovation cleaning',
      'Грузчики и подъём': 'Movers & lifting',
      'Технадзор': 'Construction supervision',
      'Резерв на непредвиденное': 'Contingency reserve',
      'Коммунальные платежи': 'Utility bills',
      'Аренда жилья на время ремонта': 'Temporary housing rent',
      'Демонтаж': 'Demolition',
      'Черновые работы': 'Rough work',
      'Отделочные работы': 'Finishing work',
      'Монтажные работы': 'Installation work',
      'Сантехника': 'Plumbing',
      'Электрика': 'Electrical',
      'Вентиляция': 'Ventilation',
      'Отопление': 'Heating',
      'Освещение': 'Lighting',
      'Мебель': 'Furniture',
      'Техника': 'Appliances',
      'Кондиционеры': 'Air conditioners',
      'Доставка': 'Delivery',
      'Проектирование': 'Design',
      'Разрешения': 'Permits',
      'Консультации': 'Consultations',
      'Инструменты': 'Tools',
      'Декор': 'Decor',
      'Прочее': 'Other',
      'Продукты': 'Groceries',
      'Рестораны и кафе': 'Restaurants & Cafes',
      'Доставка еды': 'Food delivery',
      'Топливо': 'Fuel',
      'Общественный транспорт': 'Public transport',
      'Такси': 'Taxi',
      'Обслуживание авто': 'Car maintenance',
      'Парковка': 'Parking',
      'Аренда': 'Rent',
      'Ипотека': 'Mortgage',
      'Коммунальные услуги': 'Utilities',
      'Интернет и связь': 'Internet & Communication',
      'Ремонт и обслуживание': 'Repairs & Maintenance',
      'Врачи и клиники': 'Doctors & Clinics',
      'Лекарства': 'Medications',
      'Спорт и фитнес': 'Sports & Fitness',
      'Страховка': 'Insurance',
      'Подписки': 'Subscriptions',
      'Кино и театр': 'Cinema & Theatre',
      'Путешествия': 'Travel',
      'Хобби': 'Hobbies',
      'Игры': 'Games',
      'Одежда и обувь': 'Clothing & Shoes',
      'Уход за собой': 'Personal care',
      'Курсы и обучение': 'Courses & Education',
      'Книги': 'Books',
      'Детское образование': "Children's education",
      'Подарки': 'Gifts',
      'Благотворительность': 'Charity',
      'Смартфон': 'Smartphone',
      'Ноутбук': 'Laptop',
      'Планшет': 'Tablet',
      'Наушники': 'Headphones',
      'Аксессуары': 'Accessories',
      'Ozon': 'Ozon',
      'Wildberries': 'Wildberries',
      'Яндекс.Маркет': 'Yandex Market',
      'Билеты': 'Tickets',
      'Жильё': 'Accommodation',
      'Трансфер': 'Transfer',
      'Кофейня': 'Coffee shop',
      'Кофе навынос': 'Coffee to-go',
    },
  },
  stages: {
    title: 'Stages',
    add: 'New stage',
    addItem: 'New item',
    delete: 'Delete stage',
    deleteConfirm: 'Delete this stage?',
    deleteWithItemsConfirm: 'Delete this stage? All stage tasks will also be deleted.',
    deleteItemConfirm: 'Delete this item?',
    notFound: 'Stage not found',
    noStages: 'No stages yet',
    noStagesHint: 'Create stages manually or apply a ready-made template',
    fromTemplate: 'From template',
    titleLabel: 'Stage name',
    titlePlaceholder: 'For example: Electrical',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'What is included in this stage',
    responsibleLabel: 'Assignee',
    responsiblePlaceholder: 'Contractor or team member',
    deadlineLabel: 'Deadline',
    progressLabel: 'Progress',
    statusNotStarted: 'Not started',
    statusInProgress: 'In progress',
    statusCompleted: 'Completed',
    statusBlocked: 'Blocked',
    showCompleted: 'Show completed',
    hideCompleted: 'Hide completed',
    items: 'Items',
    noItems: 'No items yet',
    itemTitleLabel: 'What needs to be done',
    itemTitlePlaceholder: 'Item description',
    addItemPlaceholder: 'Add a task...',
    itemDone: 'Done',
    changeStatus: 'Change status',
    templates: 'Stage templates',
    templateApply: 'Apply template',
    selectAll: 'Select all',
    deselectAll: 'Deselect',
    applyingTemplate: 'Applying...',
  },
  kanban: {
    title: 'Kanban',
    columnTodo: 'To do',
    columnDoing: 'In progress',
    columnDone: 'Done',
    columnBlocked: 'Blocked',
    empty: 'Empty',
    move: 'Move',
  },
  needCategories: {
    FLOORING: 'Flooring',
    TILES: 'Tiles',
    PLUMBING: 'Plumbing fixtures',
    LIGHTING: 'Lighting',
    ELECTRICAL: 'Electrical',
    DOORS: 'Doors',
    KITCHEN: 'Kitchen & appliances',
    WALLS_CEILING: 'Walls & ceiling',
    WINDOWS_TEXTILE: 'Windows & curtains',
    FURNITURE: 'Furniture',
    ELECTRONICS: 'Electronics',
    CLIMATE: 'Climate',
    SECURITY: 'Security',
    STORAGE: 'Storage',
    GARDEN: 'Garden',
    CLEANING: 'Cleaning',
    TOOLS: 'Tools',
    DECOR: 'Decor',
    TEXTILE: 'Textiles',
    BATH: 'Bathroom',
    OTHER: 'Other',
  },
  materials: {
    title: 'Materials',
    add: 'New material',
    delete: 'Delete',
    deleteConfirm: 'Delete this material?',
    noMaterials: 'Nothing added yet',
    noMaterialsHint: 'Build a shopping list or apply a template',
    fromTemplate: 'From template',
    statusActive: 'Active',
    statusBought: 'Bought',
    statusCancelled: 'Cancelled',
    nameLabel: 'Name',
    namePlaceholder: 'For example: Bathroom tiles',
    quantityLabel: 'Quantity',
    unitLabel: 'Unit',
    categoryLabel: 'Category',
    priorityLabel: 'Priority',
    priorityLow: 'Low',
    priorityMedium: 'Medium',
    priorityHigh: 'High',
    notesLabel: 'Notes',
    notesPlaceholder: 'Additional info',
    options: 'Options',
    addOption: 'Add option',
    optionTitle: 'Title',
    optionPrice: 'Price',
    optionUrl: 'Link',
    optionNotes: 'Note',
    selectOption: 'Choose',
    deselectOption: 'Deselect',
    deleteOption: 'Delete option',
    selected: 'Selected',
    estimatedTotal: 'Budget estimate',
    boughtTotal: 'Bought for',
    templates: 'Templates',
    applyTemplate: 'Apply template',
    selectItems: 'Pick items',
    itemCount_one: '{{count}} product',
    itemCount_few: '{{count}} products',
    itemCount_many: '{{count}} products',
    itemCount_other: '{{count}} products',
    productCount_one: '{{count}} product',
    productCount_few: '{{count}} products',
    productCount_many: '{{count}} products',
    productCount_other: '{{count}} products',
    deleteAllConfirm: 'Delete all products? This cannot be undone.',
    productsTitle: 'Products',
    noProducts: 'No products',
    noProductsHint: 'Add products to plan purchases',
    chooseTemplate: 'Choose a template',
    selectedCount: 'Selected: {{selected}} of {{total}}',
    deselectAll: 'Deselect all',
    applySelected: 'Apply {{count}} products',
    addOwnProduct: 'Or add your own product',
    searchPlaceholder: 'Search by name...',
    nothingByFilters: 'Nothing found for these filters',
    optionsCount_one: '{{count}} option',
    optionsCount_few: '{{count}} options',
    optionsCount_many: '{{count}} options',
    optionsCount_other: '{{count}} options',
    selectedLabel: 'Selected:',
    selectedOption: 'Selected option',
    price: 'Price',
    edit: 'Edit',
    hideTemplates: 'Hide templates',
    addMoreTemplate: 'Add another template',
    resetAndChooseTemplate: 'Reset and choose template',
    deleteProduct: 'Delete product',
    productNotFound: 'Product not found',
    openLink: 'Open link →',
    optionTitlePlaceholder: 'Name (brand, model)',
    optionPricePlaceholder: 'Price (optional)',
    optionUrlPlaceholder: 'Product link',
    linkHint: 'Paste a product link from any shop — we will fill in the name, price and photo for you.',
    pasteLink: 'Paste',
    fillManually: 'No link — fill in manually',
    previewLoading: 'Reading the product page…',
    previewFailed: 'Could not read the page — fill it in manually',
    previewEmpty: 'No product data found on the page — fill it in manually',
    previewFilled: 'Filled in: {{fields}} — check and save',
    previewForeignCurrency: 'The page price is in {{currency}} but the project is in {{project}} — enter the price yourself',
    previewField: { title: 'name', price: 'price', description: 'description', image: 'photo' },
    optionDescriptionPlaceholder: 'Description (optional)',
    adding: 'Adding...',
    deleteOptionConfirm: 'Delete this option?',
    optionsEmpty: 'Save the products you are choosing between: paste a link and we will fill in the name and price. Tick the circle on the one you pick.',
    removeImage: 'Remove photo',
    uploadImage: 'Upload photo',
    replaceImage: 'Replace photo',
    imageUploading: 'Uploading photo…',
    imageUploadFailed: 'Could not upload the photo',
    dragToReorder: 'Drag to reorder',
    reorderFailed: 'Could not save the order',
    compareView: 'Compare',
    listView: 'List',
    priceAboveCheapest: '+{{amount}} vs cheapest',
    compareNoPrice: 'No price',
    cheapest: 'Cheapest',
    deleteProductConfirm: 'Delete product? All options will also be deleted.',
    collectionsTitle: 'Collections',
    newCollection: 'New collection',
    collectionNameLabel: 'What are you choosing?',
    collectionNamePlaceholder: 'E.g. Kitchen faucet',
    collectionsEmpty: 'No collections yet',
    collectionsEmptyHint: 'A collection holds the products you are choosing between: faucets, tiles, lamps. Paste a shop link — we will fill in the name, price and photo.',
    onboarding: {
      title: 'Choose products without the mess',
      lead: 'A collection holds options for one purchase from different shops: faucets, tiles, lamps. Keep them in one place, compare and buy when you decide.',
      exampleTitle: 'Kitchen faucet',
      exampleFrom: '3 items · from $89',
      exampleItems: [
        { name: 'Lemark Comfort LM3061C', shop: 'faucetshop.com', price: '$89' },
        { name: 'Grohe Eurosmart 33281003', shop: 'Amazon', price: '$145' },
        { name: 'Hansgrohe Focus M41', shop: 'Home Depot', price: '$172' },
      ],
      benefitLink: 'Paste a shop link — we fill in the name, price and photo',
      benefitCompare: 'Compare options side by side — see which is cheaper and by how much',
      benefitKeep: 'Links won’t get lost in chats and tabs — come back when it’s time to buy',
      startLabel: 'What are you choosing now?',
      starters: ['Faucet', 'Bathroom tiles', 'Laminate', 'Chandelier', 'Sofa'],
      ownCollection: 'Custom collection',
    },
    createCollection: 'Create collection',
    collectionNoItems: 'Empty for now',
    collectionNotFound: 'Collection not found',
    deleteCollection: 'Delete collection',
    deleteCollectionConfirm: 'Delete the collection with all its products?',
    priceFrom: 'from {{price}}',
    addProduct: 'Add product',
    buy: 'Buy',
    removeProduct: 'Remove product',
    removeProductConfirm: 'Remove this product from the collection?',
    productsEmptyHint: 'Paste a product link — we will fill in the name, price and photo.',
    nothingFound: 'Nothing found',
    note: 'Note',
  },
  projects: {
    mainBlockLabel: 'What to show on the home screen',
    mainBlockHint: 'You can change this later in the home screen setup',
    newTitle: 'New project',
    editTitle: 'Project settings',
    deleteProject: 'Delete project',
    deleteConfirm: 'Permanently delete this project?',
    titleLabel: 'Project name',
    titlePlaceholder: 'For example: Apartment on the embankment',
    typeRenovation: 'Renovation',
    typeFinance: 'Finance',
    financeDisclaimer: 'This is a different app mode — pure life finance tracking. Currently an experiment.',
    budgetLabel: 'Budget',
    budgetPlaceholder: 'Amount',
    currencyLabel: 'Currency',
    currencyNoConversion: 'Changing the currency does not recalculate existing expenses, materials, or budget lines.',
    areaLabel: 'Area (m²)',
    areaPlaceholder: 'For example: 60',
    startDateLabel: 'Renovation start date',
    startDateHint: 'Used to show the current renovation day on the dashboard.',
    creating: 'Creating...',
    saving: 'Saving...',
    leaveProject: 'Leave project',
    leaveConfirm: 'Leave this project?',
  },
  members: {
    title: 'Members',
    invite: 'Invite',
    inviteLink: 'Invitation link',
    copy: 'Copy',
    copied: 'Copied!',
    expiresIn: 'Valid for {{days}} day(s)',
    revoke: 'Revoke',
    role: 'Role',
    roleOwner: 'Owner',
    roleEditor: 'Editor',
    roleViewer: 'Viewer',
    you: 'you',
    remove: 'Remove',
    removeConfirm: 'Remove this member?',
    limitReached: 'Member limit reached ({{limit}})',
    pendingInvites: 'Active invitations',
    activeMembers: 'Current members',
    inviteAsRole: 'Invite as',
    expirationLabel: 'Expires',
    expirationOptions: {
      day: '1 day',
      week: '7 days',
      month: '30 days',
    },
    createInvite: 'Create invitation',
    inviteCreated: 'Invitation created',
  },
  accept: {
    title: 'Project invitation',
    project: 'Project',
    invitedBy: 'Invited by',
    role: 'Your role',
    accept: 'Accept invitation',
    decline: 'Decline',
    accepting: 'Accepting...',
    accepted: 'You accepted the invitation',
    expired: 'The invitation expired',
    invalid: 'The invitation is invalid',
  },
  budget: {
    title: 'Budget calculator',
    desc: 'Distribute the total budget across categories and watch the limits',
    totalBudget: 'Total budget',
    planned: 'Planned',
    leftToPlan: 'Left to plan',
    overPlanned: 'Over-planned',
    distributeRemainder: 'Distribute remainder',
    distributing: 'Distributing...',
    aiSuggest: 'Suggest with AI',
    aiSuggesting: 'AI is thinking...',
    aiSuggestHint: 'AI will split the budget by project type',
    aiPromptLabel: 'Describe the project (optional)',
    aiPromptPlaceholder: 'For example: 60 m² apartment, fine finishing',
    saving: 'Saving...',
    plannedLabel: 'Plan',
    spentLabel: 'Spent',
    percentLabel: '% of budget',
    addCategory: 'Add category',
    deleteCategory: 'Delete',
    categoryNamePlaceholder: 'Category name',
    budgetReachedWarning: 'Categories total exceeds the overall budget',
    calculatorTitle: 'Budget calculator',
    calculatorSubtitle: 'Distribute the budget across categories',
    aiDistribution: 'AI budget distribution',
    aiAnalyzing: 'Analyzing...',
    availableIn: 'Available in {{time}}',
    distributeWithAi: '✨ Distribute with AI',
    planDistributed: 'Distributed by plan',
    planTotal: 'Plan total:',
    projectLimit: 'Project limit:',
    limitRemaining: 'Remaining to limit:',
    usage: 'Usage:',
    pricePerSqm: 'Price per m²:',
    plannedExpenseItems: 'Planned expense items',
    autoDistributedHint: '💡 Budget was automatically distributed by recommended categories',
    deleteCategoryConfirm: 'Delete category "{{category}}"?',
    addCategoryPrompt: 'Enter a category name',
    duplicateCategory: 'A category with this name already exists',
    categoryTooLong: 'Category name is too long (maximum 100 characters)',
    categoryInvalidChars: 'Category name can contain only letters, numbers, spaces, hyphens, parentheses, and slash',
    loadPlanError: 'Budget plan loading error',
    loadPlanFailed: 'Failed to load plan',
    saveError: 'Save error',
    distributeError: 'Distribution error',
    aiError: 'AI request error',
    distributeRemainderAuto: 'Distribute remainder automatically',
    categories: {
      'Ремонтные работы': 'Renovation work',
      'Черновые материалы': 'Rough materials',
      'Чистовая отделка': 'Finish materials',
      'Встроенная мебель': 'Built-in furniture',
      'Отдельная мебель': 'Freestanding furniture',
      'Кухонная техника': 'Kitchen appliances',
      'Бытовая техника и электроника': 'Appliances and electronics',
      'Сантехника': 'Plumbing fixtures',
      'Инженерные системы': 'Engineering systems',
      'Освещение': 'Lighting',
      'Текстиль и декор': 'Textiles and decor',
      'Прочее / Резерв': 'Other / Reserve',
    },
  },
  support: {
    title: 'Support',
    desc: 'Describe a problem or share an idea. We will reply via the Telegram bot.',
    messageLabel: 'Message',
    messagePlaceholder: 'What happened or what would you like to improve?',
    contactLabel: 'Contact (optional)',
    contactPlaceholder: 'Telegram, email, or phone',
    send: 'Send',
    sending: 'Sending...',
    sent: 'Thanks! Your message has been sent.',
    error: 'Failed to send. Please try again later.',
    history: 'Your requests',
    noRequests: 'No requests yet',
    answered: 'Reply',
  },
  reports: {
    title: 'Reports',
    cardSubtitle: 'Past reports for this project',
    markAllRead: 'Mark all read',
    empty: 'No reports yet. They will appear here after the first delivery.',
    untitledProject: 'Project',
    manual: 'Manual',
  },
  files: {
    title: 'Project files',
    estimates: 'Estimates',
    photos: 'Photos',
    uploadEstimate: 'Upload estimate',
    uploadPhoto: 'Add photo',
    empty: 'No photos yet.',
    emptyEstimates: 'No estimates yet. Upload a PDF, Excel file or a scan from your contractor.',
    download: 'Download',
    deleteConfirm: 'Delete this file?',
    tooLarge: 'File is too large (15 MB max)',
    unsupportedType: 'Unsupported file type',
    quotaExceeded: 'File limit reached for this project',
    disabled: 'File uploads are not configured for this project yet',
    parseToExpenses: 'Parse into expenses',
    columnMapping: {
      description: "Couldn't confidently detect the columns — please pick them manually.",
      descriptionColumn: 'Description',
      amountColumn: 'Amount',
      categoryColumn: 'Category',
      confirm: 'Continue',
    },
    importReview: {
      selectAll: 'Select all',
      import: 'Import ({{count}})',
    },
    importResult: {
      summary: 'Imported {{success}} of {{total}}',
      errors: 'Skipped: {{count}}',
    },
  },
  plans: {
    onboarding: {
      title: 'Your apartment plan in a couple of minutes',
      lead: 'Draw the walls — rooms, areas and finishing quantities are calculated for you. Then look at the apartment in 3D.',
      exampleRooms: {
        'room-1': 'Bedroom',
        'room-2': 'Kitchen-living',
        'room-3': 'Bedroom 2',
        'room-4': 'Bathroom',
      },
      benefitDraw: 'Walls on a grid or over a photo of the plan — a closed outline becomes a room with its area',
      benefitLayers: 'Furniture, sockets and plumbing in layers — “Auto” arranges them by room',
      benefitFinish: 'Floor and wall finishes: wall area without openings and baseboard length for the estimate',
      benefit3d: 'A 3D view of the apartment with furniture and finishes',
      heroAlt: 'Example: a two-bedroom apartment with furniture in 3D',
      startLabel: 'Start with',
      withFurniture: 'with furniture',
      blank: 'From scratch',
      blankHint: 'Draw your own walls or trace a photo',
      viewerHint: 'The project owner has not added a floor plan yet.',
    },
    tour: {
      label: 'How to use the planner',
      open: 'How to use',
      skip: 'Close tips',
      next: 'Next',
      back: 'Back',
      done: 'Got it',
      walls: {
        title: 'Draw walls',
        text: 'Wall tool: press and drag to draw a wall. Taps at corners draw walls in a chain. Have a photo of the plan? Upload it with the image button at the top — AI will trace the walls.',
      },
      rooms: {
        title: 'Rooms appear by themselves',
        text: 'A closed outline of walls becomes a room with its area. Tap a room to set its name, floor and wall finish and see wall area without openings and the baseboard.',
      },
      layers: {
        title: 'Furniture and utilities',
        text: 'Switch the layer: furniture, electrical, plumbing. Items come from the catalog, and “Auto” arranges them by room.',
      },
      '3d': {
        title: 'See it in 3D',
        text: 'The whole apartment with furniture and finishes. Rotate with a finger; the scissors cut away the near walls.',
      },
    },
    title: 'Floor plans',
    cardSubtitle: 'Draw your apartment layout and get room areas',
    create: 'New',
    createFirst: 'Draw a floor plan',
    defaultName: 'Floor plan {{n}}',
    emptyTitle: 'No floor plans yet',
    emptyText: 'Draw walls on the grid — every closed outline becomes a room with its area.',
    deleteConfirm: 'Delete floor plan “{{name}}”?',
    notFound: 'Floor plan not found',
    nameLabel: 'Floor plan name',
    saved: 'Saved',
    saving: 'Saving…',
    saveError: 'Not saved',
    undo: 'Undo',
    redo: 'Redo',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    view3d: '3D',
    view3dOpen: 'View in 3D',
    view3dTitle: 'Floor plan in 3D',
    view3dClose: 'Close 3D',
    view3dLabels: 'Room labels',
    view3dCut: 'Cut away near walls',
    wallsNet: 'Walls excl. openings',
    baseboard: 'Baseboard',
    floorFinish: 'Floor',
    wallFinish: 'Walls',
    finishFloor: {
      WOOD: 'Parquet',
      LAMINATE: 'Laminate',
      TILE: 'Tile',
      STONE: 'Porcelain',
      CARPET: 'Carpet',
      CONCRETE: 'Concrete',
    },
    finishWall: {
      PAINT: 'Paint',
      WALLPAPER: 'Wallpaper',
      TILE: 'Tile',
      PLASTER: 'Plaster',
      PANELS: 'Panels',
    },
    view3dReset: 'Reset view',
    view3dSqm: 'm²',
    view3dEmpty: 'Draw some walls and a 3D model of the apartment will appear here',
    view3dHint: 'Drag to rotate · right button or two fingers to pan · wheel or pinch to zoom',
    fit: 'Fit to screen',
    toolSelect: 'Select',
    toolWall: 'Wall',
    done: 'Done',
    hintEmpty: 'Pick “Wall” and place points on the grid',
    emptyReadOnly: 'This plan is empty',
    hintWallStart: 'Press and drag — release at the end of the wall. Or tap to place corners',
    hintWallNext: 'Next corner. Close the outline to get a room',
    roomDefault: 'Room {{n}}',
    roomName: 'Room name',
    wall: 'Wall',
    length: 'Length',
    wallAngle: 'Tilt from horizontal',
    cornerAngle: 'Corner angle ({{side}})',
    side: { left: 'left', right: 'right', top: 'top', bottom: 'bottom' },
    angleHint: 'Tilt rotates the wall around its middle. Corner angle moves this wall; the adjacent one stays in place.',
    thickness: 'Thickness',
    area: 'Area',
    perimeter: 'Perimeter',
    unitM: 'm',
    unitM2: 'm²',
    roomsCount_one: '{{count}} room',
    roomsCount_other: '{{count}} rooms',
    bgTitle: 'Background photo',
    bgAdd: 'Add photo',
    bgReplace: 'Replace photo',
    bgOpacity: 'Opacity',
    bgLock: 'Lock',
    bgUnlock: 'Unlock',
    bgLockedHint: 'Locked — dragging and resizing are disabled',
    bgDeleteConfirm: 'Remove the background photo?',
    chooseTemplate: 'What should we start from?',
    templateBlank: 'Blank plan',
    templateBlankHint: 'Trace walls from scratch',
    templateStudio: 'Studio',
    templateOneRoom: 'One-bedroom',
    templateTwoRoom: 'Two-bedroom',
    newWallThickness: 'Wall thickness, cm',
    thicknessCustom: 'Custom thickness',
    unitCm: 'cm',
    unitMm: 'mm',
    lengthUnit: 'Length unit',
    roomAutoHint: 'Rooms follow the walls: move or delete walls to change or remove a room.',
    toolDoor: 'Door',
    toolWindow: 'Window',
    hintDoor: 'Tap a wall to insert a door',
    hintWindow: 'Tap a wall to insert a window',
    doorWidth: 'Door width, cm',
    windowWidth: 'Window width, cm',
    widthCustom: 'Custom width',
    width: 'Width',
    door: 'Door',
    window: 'Window',
    doorFlipHinge: 'Move hinges to the other side',
    doorFlipSide: 'Swing to the other side',
    openingFromCorner: 'From wall start',
    openingTapWall: 'Tap right on a wall',
    openingWallTooShort: 'The wall is too short for an opening',
    openingOverlap: 'There is already an opening here — pick another spot',
    cmValue: '{{value}} cm',
    roomsList: 'Rooms',
    roomsEmpty: 'No rooms yet — close the walls and they will appear here.',
    layers: 'Layers',
    layerPlan: 'Plan',
    layerPlanHint: 'Walls, doors, windows, rooms',
    layerFurniture: 'Furniture',
    layerEditing: 'Editing now',
    layersHide: 'Hide layers',
    room: 'Room',
    walls: 'Walls',
    openings: 'Doors and windows',
    layerShow: 'Show layer',
    layerHide: 'Hide layer',
    layersHint: 'Tap a layer to edit it. Other layers stay dimmed and out of the way.',
    itemsCount_one: '{{count}} item',
    itemsCount_other: '{{count}} items',
    addFurniture: 'Add',
    hintFurniture: 'Tap “Add” to place furniture',
    rotateLeft: 'Rotate counter-clockwise',
    rotateRight: 'Rotate clockwise',
    duplicate: 'Duplicate',
    itemWidth: 'Width',
    itemDepth: 'Depth',
    itemRotation: 'Rotation',
    catalogSearch: 'Search by name',
    layerElectrical: 'Electrical',
    layerPlumbing: 'Plumbing',
    hintElectrical: 'Tap “Add” — sockets and switches snap to walls',
    hintPlumbing: 'Tap “Add” — water and drain outlets snap to walls',
    catalogFurniture: 'Add furniture',
    catalogElectrical: 'Add electrical',
    catalogPlumbing: 'Add plumbing',
    itemElevation: 'Height from floor',
    autoArrange: 'Auto',
    autoReplaceConfirm: 'Re-arrange the “{{layer}}” layer? Its current items will be replaced — you can undo with ↶.',
    autoDone_one: 'Placed {{count}} item — adjust by hand or undo ↶',
    autoDone_other: 'Placed {{count}} items — adjust by hand or undo ↶',
    autoEmptyFurniture: 'Nothing to place: close the walls into rooms and name them (Bedroom, Kitchen…)',
    autoEmptyElectrical: 'Nothing to place: draw rooms and doors first',
    autoEmptyPlumbing: 'Place bathroom and kitchen fixtures in the “Furniture” layer first',
    toolPassage: 'Opening',
    toolBalcony: 'Balcony',
    toolDivider: 'Zone border',
    hintDividerStart: 'Draw a border between zones with no wall — e.g. a hallway and an open kitchen-living room',
    traceHint: 'Finds walls, doors and windows on the drawing; AI reads the scale from labeled dimensions. Works best on clean plans; diagonal walls are not detected.',
    traceFound: 'Walls found: {{count}}',
    traceLongest: 'Length of the longest wall',
    traceScaleHint: 'The photo has no units: enter the real length of the longest wall to set the scale.',
    traceApply: 'Draw walls',
    traceReplaceConfirm: 'The plan already has walls — replace them with the detected ones?',
    aiCheckBtn: 'Draw with AI',
    aiCheckRunning: 'AI is drawing…',
    aiCheckFailed: 'Could not recognize the photo',
    aiScaleUnavailable: 'AI is unavailable — set the scale manually',
    aiScaleHint: 'The scale comes from a dimension labeled on the plan — check the longest wall length and adjust if needed.',
    aiCheckTitle: 'AI verdict',
    aiCheckWalls: 'Walls are visible',
    aiCheckDimensions: 'Dimensions are labeled',
    aiCheckThickness: 'Wall thickness is clear',
    ceilingHeight: 'Ceiling height',
    ceilingApplyAll: 'Apply to all',
    wallsArea: 'Wall area',
    volume: 'Volume',
    unitM3: 'm³',
    toolRuler: 'Ruler',
    hintRulerItem: 'Tap an item to see its distances to walls and furniture',
    hintRulerA: 'Tap the first point: a wall corner or an item edge',
    hintRulerB: 'Tap the second point',
    rulerModeItem: 'From item',
    rulerModePoints: 'Two points',
    hintPassage: 'Tap a wall to make a doorless opening',
    hintBalcony: 'Tap an exterior wall — the balcony goes on its outer side',
    passageWidth: 'Opening width, cm',
    passage: 'Opening',
    balconyWidth: 'Balcony width',
    balconyDepth: 'Balcony depth',
    balconyDefault: 'Balcony',
    balconyDefaultN: 'Balcony {{n}}',
    balconyShort: 'balcony',
    balconyTapWall: 'Tap right on an exterior wall',
    balconyInnerWall: 'A balcony can only go on an exterior wall',
    balconyNoSpace: 'This spot is taken — pick another',
    outdoorBadge: 'not in total',
    outdoorHint: 'A balcony is counted separately and is not part of the total area. It is defined by its railing — remove the railing and it becomes a regular room.',
    railing: 'Balcony railing',
    railingHint: 'A parapet instead of a wall: an outline closed with it is a balcony, not counted in the total area',
    divider: 'Zone border',
    dividerToggle: 'No wall — zone border',
    dividerHint: 'Splits an open space into rooms: no thickness, takes no floor area, hidden in 3D',
  },
  catalog: {
    category: {
      living: 'Living room',
      bedroom: 'Bedroom',
      kitchen: 'Kitchen & dining',
      bathroom: 'Bathroom',
      other: 'Other',
      hallway: 'Hallway',
      sockets: 'Sockets',
      switches: 'Switches',
      lighting: 'Lighting',
      equipment: 'Equipment',
      water: 'Water supply',
      sewerage: 'Drainage',
    },
    sofa3: '3-seat sofa',
    sofa2: '2-seat sofa',
    cornerSofa: 'Corner sofa',
    armchair: 'Armchair',
    coffeeTable: 'Coffee table',
    tvStand: 'TV stand',
    shelf: 'Shelving',
    plant: 'Plant',
    doubleBed: 'Double bed',
    singleBed: 'Single bed',
    nightstand: 'Nightstand',
    wardrobe: 'Wardrobe',
    dresser: 'Dresser',
    kitchenCounter: 'Kitchen counter',
    stove: 'Stove',
    fridge: 'Fridge',
    kitchenSink: 'Kitchen sink',
    diningTable: 'Dining table',
    roundTable: 'Round table',
    chair: 'Chair',
    bathtub: 'Bathtub',
    shower: 'Shower',
    toilet: 'Toilet',
    washbasin: 'Washbasin',
    washer: 'Washing machine',
    desk: 'Desk',
    officeChair: 'Office chair',
    pouf: 'Pouf',
    sideboard: 'Sideboard',
    bookcase: 'Bookcase',
    rug: 'Rug',
    floorLamp: 'Floor lamp',
    kingBed: 'Bed 180×200',
    kidsBed: 'Kids bed',
    crib: 'Crib',
    vanityTable: 'Vanity table',
    slidingWardrobe: 'Sliding wardrobe',
    dishwasher: 'Dishwasher',
    oven: 'Oven',
    kitchenIsland: 'Kitchen island',
    cornerKitchen: 'Corner kitchen',
    barStool: 'Bar stool',
    smallBathtub: 'Bathtub 150 cm',
    showerTray: 'Shower tray',
    bidet: 'Bidet',
    doubleSink: 'Double sink',
    dryer: 'Dryer',
    waterHeater: 'Water heater',
    towelRail: 'Towel rail',
    shoeCabinet: 'Shoe cabinet',
    hallWardrobe: 'Hallway wardrobe',
    bench: 'Bench',
    coatRack: 'Coat rack',
    radiator: 'Radiator',
    piano: 'Piano',
    treadmill: 'Treadmill',
    socket: 'Socket',
    socketDouble: 'Double socket',
    socketKitchen: 'Countertop socket',
    socketWaterproof: 'Waterproof socket',
    socketPower: 'Power socket (stove)',
    tvSocket: 'TV socket',
    lanSocket: 'Network socket',
    switch: 'Switch',
    switchDouble: 'Two-gang switch',
    switchPass: 'Two-way switch',
    dimmer: 'Dimmer',
    ceilingLight: 'Ceiling light',
    chandelier: 'Chandelier',
    spotLight: 'Spotlight',
    sconce: 'Wall sconce',
    ledStrip: 'LED strip',
    electricalPanel: 'Electrical panel',
    junctionBox: 'Junction box',
    thermostat: 'Thermostat',
    floorHeating: 'Underfloor heating',
    airConditioner: 'Air conditioner',
    exhaustFan: 'Exhaust fan',
    intercom: 'Intercom',
    waterCold: 'Cold water',
    waterHot: 'Hot water',
    waterRiser: 'Water riser',
    valve: 'Valve',
    waterMeter: 'Water meter',
    sewerOutlet: 'Drain outlet',
    sewerRiser: 'Drain riser',
    floorDrain: 'Floor drain',
    manifold: 'Manifold',
    waterFilter: 'Water filter',
    heatingBoiler: 'Boiler',
  },
  analytics: {
    title: 'Analytics',
    cardSubtitle: 'Charts and insights on your spending',
    accountingDays: '{{count}} days tracked',
    empty: 'No paid expenses yet. Add expenses and charts and metrics will show up here.',
    total: 'Total',
    count: 'Expenses',
    average: 'Average',
    median: 'Median',
    perDay: 'Per day',
    days: 'Days tracked',
    maxExpense: 'Biggest purchase',
    spendingOverTime: 'Spending over time',
    cumulative: 'Cumulative',
    byCategory: 'By category',
    operations: '{{count}} ops',
    peakDay: 'Most expensive day',
    peakWeek: 'Most expensive week',
    topExpenses: 'Top expenses',
    uncategorized: 'Uncategorized',
    otherCategories: 'Other categories',
    note: 'Only paid expenses are counted; amounts are converted to the project currency.',
    updatedAt: 'updated {{date}}',
  },
  yandex: {
    title: 'Yandex sign-in',
    redirecting: 'Redirecting to etap...',
    error: 'Authentication error',
    cancelled: 'Sign-in cancelled',
    retry: 'Try again',
  },
  editor: {
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    bulletList: 'Bulleted list',
    orderedList: 'Numbered list',
    taskList: 'Checklist',
    link: 'Link',
    unlink: 'Remove link',
    h1: 'Heading 1',
    h2: 'Heading 2',
    h3: 'Heading 3',
    placeholder: 'Start typing...',
  },
} as const;
